import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const Contacto = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: ''
  });

  const [enviando, setEnviando] = useState(false);
  const [mensajeEnviado, setMensajeEnviado] = useState(null);

  // ⚠️ CAMBIA ESTOS VALORES POR LOS TUYOS DE EMAILJS ⚠️
  const EMAILJS_SERVICE_ID = 'service_66k7pje';  // Tu Service ID
  const EMAILJS_TEMPLATE_ID = 'template_99xsk3e'; // Tu Template ID
  const EMAILJS_PUBLIC_KEY = 'eq70P5EiDG_Pt5LSw';     // Tu Public Key

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setMensajeEnviado(null);

    try {
      const templateParams = {
        from_name: formData.nombre,
        from_email: formData.email,
        telefono: formData.telefono,
        mensaje: formData.mensaje,
        to_name: 'Phone Paradise',
      };

      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        templateParams,
        EMAILJS_PUBLIC_KEY
      );

      setMensajeEnviado('success');
      setFormData({ nombre: '', email: '', telefono: '', mensaje: '' });
      
      // También enviar confirmación por WhatsApp
      const telefonoTienda = "34640975055";
      const mensajeWhatsApp = `Hola, soy ${formData.nombre}. Te he enviado un mensaje desde la web: ${formData.mensaje}. Mi teléfono es ${formData.telefono || 'no especificado'}.`;
      window.open(`https://wa.me/${telefonoTienda}?text=${encodeURIComponent(mensajeWhatsApp)}`, '_blank');
      
    } catch (error) {
      console.error('Error al enviar:', error);
      setMensajeEnviado('error');
    } finally {
      setEnviando(false);
      setTimeout(() => setMensajeEnviado(null), 5000);
    }
  };

  // Función para WhatsApp directo
  const handleWhatsAppClick = () => {
    const telefono = "34640975055";
    window.open(`https://wa.me/${telefono}`, '_blank');
  };

  // Función para llamada telefónica
  const handleLlamada = (numero) => {
    window.location.href = `tel:${numero}`;
  };

  return (
    <div>
      <div className="container">
        <div className="section-header">
          <h2>Contacto</h2>
          <div className="underline"></div>
        </div>

        <div className="contact-grid">
          <div className="contact-info">
            <h3>📍 Visítanos</h3>
            <div className="info-item">
              <div className="info-icon">🏠</div>
              <div>
                <strong>C/MAYOR 17</strong><br />
                08389 PALAFOLLS, BARCELONA
              </div>
            </div>

            <div className="info-item" onClick={() => handleLlamada("640975055")} style={{ cursor: 'pointer' }}>
              <div className="info-icon">📞</div>
              <div>
                <strong>Teléfono:</strong><br />
                640 975 055<br />
                931 781 420
              </div>
            </div>

            <div className="info-item" onClick={handleWhatsAppClick} style={{ cursor: 'pointer' }}>
              <div className="info-icon">💬</div>
              <div>
                <strong>WhatsApp:</strong><br />
                ¡Escríbenos para consultas rápidas!
              </div>
            </div>

            <div className="map">
              <iframe
                title="mapa"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2986.123456789012!2d2.748373!3d41.666667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12bb4a2d4f5c6d7e%3A0x123456789abcdef!2sCarrer%20Major%2C%2017%2C%2008389%20Palafolls%2C%20Barcelona!5e0!3m2!1ses!2ses!4v1234567890123!5m2!1ses!2ses"
                width="100%"
                height="250"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>

          <div className="contact-form">
            <h3>✉️ Envíanos un mensaje</h3>
            
            {mensajeEnviado === 'success' && (
              <div style={{ 
                background: '#9DD8CC', 
                color: '#1A1A1A', 
                padding: '12px', 
                borderRadius: '12px', 
                marginBottom: '1rem',
                textAlign: 'center'
              }}>
                ✅ ¡Mensaje enviado! Te responderemos pronto.
              </div>
            )}
            
            {mensajeEnviado === 'error' && (
              <div style={{ 
                background: '#FFE5E5', 
                color: '#D32F2F', 
                padding: '12px', 
                borderRadius: '12px', 
                marginBottom: '1rem',
                textAlign: 'center'
              }}>
                ❌ Error al enviar. Intenta de nuevo o escríbenos por WhatsApp.
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nombre completo *</label>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Teléfono</label>
                <input
                  type="tel"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  placeholder="Opcional pero recomendado"
                />
              </div>

              <div className="form-group">
                <label>Mensaje *</label>
                <textarea
                  name="mensaje"
                  rows="5"
                  value={formData.mensaje}
                  onChange={handleChange}
                  required
                  placeholder="¿En qué podemos ayudarte?"
                ></textarea>
              </div>

              <button type="submit" className="btn" disabled={enviando}>
                {enviando ? 'Enviando...' : 'Enviar mensaje'}
              </button>
            </form>

            <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
              <p style={{ fontSize: '0.8rem', color: '#6B7280' }}>
                O si lo prefieres, escríbenos directamente a nuestro WhatsApp
              </p>
              <button 
                className="btn-outline" 
                onClick={handleWhatsAppClick}
                style={{ marginTop: '0.5rem', display: 'inline-flex', alignItems: 'center', gap: '8px' }}
              >
                💬 WhatsApp
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="whatsapp-float" onClick={handleWhatsAppClick}>
        💬
      </div>
    </div>
  );
};

export default Contacto;